import { createTheme } from "@mui/material/styles";
import {brandingSettings} from "./branding";

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brandingSettings.primaryColor,
      contrastText: "#ffffff"
    },
    secondary: {
      main: brandingSettings.secondaryColor,
      contrastText: "#eee"
    },
    info: {
      main: "#fff"
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
   text:{
    primary:brandingSettings.textcolorPrimary,
    secondary:brandingSettings.textcolorSecondary
   }
  },  
  typography: {
    fontSize: brandingSettings.baseFontSize,
    fontFamily: brandingSettings.baseFont,
    body1: {
      fontSize: brandingSettings.bodyFontSize
    }
  }
});


export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: brandingSettings.primaryColorDark
    },
    secondary: {
      main: brandingSettings.secondaryColorDark,
      contrastText: "#333"
    },
    info: {
      main: brandingSettings.primaryColorDark
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
   text:{
    primary:brandingSettings.textcolorPrimaryDark,
    secondary:brandingSettings.textcolorSecondaryDark
   }
  },
  typography: {
    fontSize: brandingSettings.baseFontSize,
    fontFamily: brandingSettings.baseFont,
    body1: {
      fontSize: brandingSettings.bodyFontSize
    }
  }
});
